import { useEffect, useRef } from "react";

function useDocumentTitle(title: string, prevailOnUnmount = false) {
  const defaultTitle = useRef(document.title);
  const defaultDescription = useRef(
    document.querySelector('meta[name="description"]')
  );

  useEffect(() => {
    document.title = title;
    if (defaultDescription.current) {
      defaultDescription.current.setAttribute(
        "content",
        `${title} web application`
      );
    }
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = defaultTitle.current;
        if (defaultDescription.current) {
          defaultDescription.current.setAttribute(
            "content",
            `${defaultTitle.current} web application`
          );
        }
      }
    },
    []
  );
}

export default useDocumentTitle;
